import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer({ siteLang }) {
  const navigate = useNavigate();

  const content = {
    FR: {
      tagline: 'La carte de visite du mannequin.',
      produit: 'Produit',
      legal: 'Légal',
      suivez: 'Suivez-nous',
      links: {
        produit: [
          { label: 'Créer mon composite', path: '/editeur' },
          { label: 'Le composite card', path: '/composite-card' },
          { label: 'Comment ça marche', path: '/comment-ca-marche' },
          { label: 'Tarifs', path: '/tarifs' },
          { label: 'FAQ', path: '/faq' },
          { label: 'Contact', path: '/contact' },
        ],
        legal: [
          { label: 'CGU', path: '/cgu' },
          { label: 'Politique de confidentialité', path: '/confidentialite' },
        ],
        social: [
          { label: 'Instagram', url: 'https://instagram.com/compify' },
          { label: 'TikTok', url: 'https://tiktok.com/@compify' },
          { label: 'LinkedIn', url: 'https://linkedin.com/company/compify' },
        ]
      },
    },
    EN: {
      tagline: 'The model composite card maker.',
      produit: 'Product',
      legal: 'Legal',
      suivez: 'Follow us',
      links: {
        produit: [
          { label: 'Create my composite', path: '/editeur' },
          { label: 'The composite card', path: '/composite-card' },
          { label: 'How it works', path: '/comment-ca-marche' },
          { label: 'Pricing', path: '/tarifs' },
          { label: 'FAQ', path: '/faq' },
          { label: 'Contact', path: '/contact' },
        ],
        legal: [
          { label: 'Terms of Service', path: '/cgu' },
          { label: 'Privacy Policy', path: '/confidentialite' },
        ],
        social: [
          { label: 'Instagram', url: 'https://instagram.com/compify' },
          { label: 'TikTok', url: 'https://tiktok.com/@compify' },
          { label: 'LinkedIn', url: 'https://linkedin.com/company/compify' },
        ]
      },
    }
  };

  const d = content[siteLang || 'FR'];

  const linkStyle = {
    color: '#555', fontSize: '13px', cursor: 'pointer',
    display: 'block', marginBottom: '10px', textDecoration: 'none',
    transition: 'color 0.2s', letterSpacing: '0.3px'
  };

  return (
    <footer style={{ backgroundColor: '#0a0a0a', borderTop: '1px solid #1a1a1a' }}>
      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '64px 24px 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '48px', marginBottom: '48px' }}>

          {/* Logo + tagline */}
          <div>
            <img src="/logo-compify.svg" alt="Compify" onClick={() => navigate('/')} style={{ width: '140px', cursor: 'pointer', display: 'block', marginBottom: '12px' }} />
            <p style={{ color: '#444', fontSize: '13px', lineHeight: 1.7, margin: '0 0 24px', maxWidth: '220px' }}>{d.tagline}</p>
            <div style={{ display: 'flex', gap: '8px' }}>
              {['FR', 'EN'].map(lang => (
                <span key={lang} style={{ color: (siteLang || 'FR') === lang ? '#FF0066' : '#333', fontSize: '11px', fontWeight: '700', letterSpacing: '2px', cursor: 'pointer' }}>
                  {lang}
                </span>
              ))}
            </div>
          </div>

          {/* Produit */}
          <div>
            <p style={{ color: '#fff', fontSize: '11px', fontWeight: '700', letterSpacing: '2px', margin: '0 0 20px', textTransform: 'uppercase' }}>{d.produit}</p>
            {d.links.produit.map((link, i) => (
              <span key={i} onClick={() => navigate(link.path)} style={linkStyle}
                onMouseEnter={e => e.target.style.color = '#FF0066'}
                onMouseLeave={e => e.target.style.color = '#555'}>
                {link.label}
              </span>
            ))}
          </div>

          {/* Légal */}
          <div>
            <p style={{ color: '#fff', fontSize: '11px', fontWeight: '700', letterSpacing: '2px', margin: '0 0 20px', textTransform: 'uppercase' }}>{d.legal}</p>
            {d.links.legal.map((link, i) => (
              <span key={i} onClick={() => navigate(link.path)} style={linkStyle}
                onMouseEnter={e => e.target.style.color = '#FF0066'}
                onMouseLeave={e => e.target.style.color = '#555'}>
                {link.label}
              </span>
            ))}
          </div>

          {/* Réseaux */}
          <div>
            <p style={{ color: '#fff', fontSize: '11px', fontWeight: '700', letterSpacing: '2px', margin: '0 0 20px', textTransform: 'uppercase' }}>{d.suivez}</p>
            {d.links.social.map((link, i) => (
              <a key={i} href={link.url} target="_blank" rel="noopener noreferrer" style={linkStyle}
                onMouseEnter={e => e.target.style.color = '#FF0066'}
                onMouseLeave={e => e.target.style.color = '#555'}>
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Séparateur */}
        <div style={{ borderTop: '1px solid #1a1a1a', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p style={{ color: '#333', fontSize: '11px', margin: 0, letterSpacing: '1px' }}>
            © 2026 Compify · {siteLang === 'FR' ? 'Compify est un produit édité par Valia • ' : 'Compify is a product published by Valia • '}
            <a href="https://www.valia.agency" target="_blank" rel="noopener noreferrer" style={{ color: '#FF0066', textDecoration: 'none' }}>www.valia.agency</a>
          </p>
          <img src="/logo-compify.svg" alt="Compify" onClick={() => navigate('/')} style={{ height: '24px', cursor: 'pointer', opacity: 0.4 }} />
        </div>
      </div>
    </footer>
  );
}